import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { gtagPageView } from '@m/utils/gtag';

/**
 * Sends GA4 `page_view` events for client-side navigation.
 *
 * Keyed on pathname only, deliberately: the discovery map rewrites
 * `?lat/?lng/?start/?end` through `history.replace` on nearly every map nudge,
 * date change, and filter change, so keying on the full location would emit a
 * page view per interaction and wreck landing-page and session reporting.
 *
 * The base snippet sets `send_page_view: false`, so this also owns the initial
 * page view — the effect fires on mount.
 */
export function useGtagPageViews() {
  const { pathname } = useLocation();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastTrackedPath.current === pathname) {
      return;
    }
    lastTrackedPath.current = pathname;
    gtagPageView({
      page_location: window.location.href,
      page_path: pathname,
      page_title: document.title,
    });
  }, [pathname]);
}
